import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import qr from "../assets/images/qr.JPG";
import authFetch from '../axios';

const Guy = () => {
    const [loading1, setLoading1] = useState(true);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [productDialog, setProductDialog] = useState(false);
    const [products, setProducts] = useState([]);
    const [first, setFirst] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);

    const hideDialog = () => {
        setProductDialog(false);
    };

    const openNew = () => {
        setProductDialog(true);
    };

    useEffect(() => {
        const getDatz = async () => {
            try {
                setLoading1(true);
                const page = Math.floor(first / perPage) + 1;
                const statz = await authFetch.get('get-device', { params: { page, per_page: perPage } });
                setProducts(statz.data?.data ?? []);
                setTotalRecords(statz.data?.pagination?.total ?? 0);
            } catch (error) {
                console.error('Error fetching devices:', error);
            } finally {
                setLoading1(false);
            }
        };
        getDatz();
    }, [first, perPage]);

    useEffect(() => {
        initFilters1();
    }, []);

    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setGlobalFilterValue1('');
    };

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = { ...filters1 };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    };

    const clearFilter1 = () => {
        initFilters1();
    };

    const onPage = (event) => {
        setFirst(event.first);
        setPerPage(event.rows);
    };

    const renderHeader1 = () => {
        return (
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3">
                <span className="p-input-icon-left w-full md:w-auto">
                    <i className="pi pi-search" />
                    <InputText 
                        value={globalFilterValue1} 
                        onChange={onGlobalFilterChange1} 
                        placeholder="Search devices..." 
                        className="w-full md:w-20rem surface-50"
                    />
                </span>
                <div className="flex gap-2">
                    <Button 
                        type="button" 
                        icon="pi pi-filter-slash" 
                        label="Clear" 
                        className="p-button-outlined p-button-secondary" 
                        onClick={clearFilter1} 
                    />
                </div>
            </div>
        );
    };

    const header1 = renderHeader1();

    const serialNumberTemplate = (rowData, options) => {
        return first + options.rowIndex + 1;
    };

    return (
        <div className="surface-ground px-4 py-5 md:px-6 lg:px-8 w-full">
            <div className="grid">
                <div className="col-12 mb-5">
                    <div className="flex align-items-center justify-content-between">
                        <div>
                            <span className="text-900 text-3xl font-medium">Device Management</span>
                            <div className="text-500 mt-2">Manage and monitor all enterprise registered devices</div>
                        </div>
                        <Button 
                            label="Onboard Device" 
                            icon="pi pi-plus" 
                            className="p-button-success shadow-2" 
                            onClick={openNew}
                        />
                    </div>
                </div>

                <div className="col-12">
                    <div className="surface-card shadow-2 p-4 border-round">
                        <DataTable 
                            value={products} 
                            filters={filters1}
                            loading={loading1}
                            responsiveLayout="stack" 
                            breakpoint="960px"
                            header={header1}
                            lazy
                            paginator
                            rows={perPage}
                            first={first}
                            totalRecords={totalRecords}
                            onPage={onPage}
                            className="p-datatable-sm"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" 
                            rowsPerPageOptions={[20, 50, 100]}
                        >
                            <Column header="S/N" body={serialNumberTemplate} className="font-medium" style={{ minWidth: '5rem' }}></Column>
                            <Column field="imei" header="IMEI" style={{ minWidth: '14rem' }}></Column>
                            <Column field="serial_number" header="Serial Number" style={{ minWidth: '14rem' }}></Column>
                            <Column field="model" header="Model" style={{ minWidth: '8rem' }}></Column>
                            <Column field="color" header="Color" style={{ minWidth: '8rem' }}></Column>
                            <Column field="status" header="Status" style={{ minWidth: '8rem' }}></Column>
                            <Column field="last_seen" header="Last Seen" style={{ minWidth: '10rem' }}></Column>
                        </DataTable>
                    </div>
                </div>

                <Dialog 
                    visible={productDialog} 
                    style={{ width: '450px' }} 
                    header="Onboard New Device" 
                    modal 
                    className="p-fluid" 
                    onHide={hideDialog}
                >
                    <div className="text-center">
                        <p className="text-700 mb-4">Scan the QR code below to quickly register this device into the MDM system.</p>
                        <img src={qr} alt={'qr-code'} width="100%" className="border-round shadow-2 mb-3" />
                        <div className="surface-50 p-3 border-round flex align-items-center justify-content-center gap-2">
                            <i className="pi pi-info-circle text-blue-500"></i>
                            <span className="text-600 text-sm">QR codes are valid for 24 hours</span>
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    );
};

export default Guy;
